export const REQUEST_DEVICE_SN = 'REQUEST_DEVICE_SN';
export const SELECT_SUB = 'SELECT_SUB';
export const SELECT_PLAN = 'SELECT_PLAN';
export const ACTIVATION_COMPLETE = 'ACTIVATION_COMPLETE';
export const ACTIVATION_ERROR = 'ACTIVATION_ERROR';
export const PAYMENT_ERROR = 'PAYMENT_ERROR';
export const OFFLINE_ERROR = 'OFFLINE_ERROR';
export const PROCESSING = 'PROCESSING';
